<template>
  <div class="container">
    <v-card>
      <v-card-title>
        <v-btn icon @click="$router.go(-1)"><v-icon>mdi-arrow-left</v-icon></v-btn>
         Τιμοκατάλογος: {{ pricelist.name }}
      </v-card-title>

      <v-tabs v-model="tab">
        <v-tab>ΑΝΑ ΠΡΟΪΟΝ</v-tab>
        <v-tab>ΑΝΑ ΚΑΤΗΓΟΡΙΑ</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- Product Entries Tab -->
        <v-tab-item>
          <v-data-table :headers="productHeaders" :items="productEntries" class="elevation-1">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Είδη</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="createProductEntry">ΠΡΟΣΘΗΚΗ</v-btn>
              </v-toolbar>
            </template>
            <template v-slot:[`item.product_code`]="{ item }">
                {{ getProductCode(item.product_id) }}
            </template>
            <template v-slot:[`item.product_name`]="{ item }">
                {{ getProductName(item.product_id) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="editProductEntry(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteProductEntry(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-tab-item>

        <!-- Category Entries Tab -->
        <v-tab-item>
          <v-data-table :headers="categoryHeaders" :items="categoryEntries" class="elevation-1">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Κατηγορίες</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="createCategoryEntry">ΠΡΟΣΘΗΚΗ</v-btn>
              </v-toolbar>
            </template>
             <template v-slot:[`item.category_name`]="{ item }">
                {{ getCategoryName(item.category_id) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="editCategoryEntry(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteCategoryEntry(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Product Entry Dialog -->
    <v-dialog v-model="productDialog" max-width="500px">
      <v-card>
        <v-card-title>Είδος Τιμοκαταλόγου</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="editedProductEntry.product_id"
                  :items="products"
                  :item-text="productDisplayName"
                  item-value="id"
                  label="Προϊόν"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editedProductEntry.price" label="Τιμή" type="number"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeProductDialog">ΑΚΥΡΟ</v-btn>
          <v-btn color="blue darken-1" text @click="saveProductEntry">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Category Entry Dialog -->
    <v-dialog v-model="categoryDialog" max-width="500px">
      <v-card>
        <v-card-title>Κατηγορία Τιμοκαταλόγου</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                 <v-autocomplete
                  v-model="editedCategoryEntry.category_id"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  label="Κατηγορία"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editedCategoryEntry.discount_percentage" label="Έκπτωση (%)" type="number"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeCategoryDialog">ΑΚΥΡΟ</v-btn>
          <v-btn color="blue darken-1" text @click="saveCategoryEntry">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    tab: 0,
    pricelist: {},
    productEntries: [],
    categoryEntries: [],
    products: [],
    categories: [],
    
    productDialog: false,
    categoryDialog: false,

    productHeaders: [
      { text: 'Κωδικός', value: 'product_code' },
      { text: 'Προϊόν', value: 'product_name' },
      { text: 'Τιμή', value: 'price' },
      { text: 'Ενέργειες', value: 'actions', sortable: false },
    ],
    categoryHeaders: [
      { text: 'Κατηγορία', value: 'category_name' },
      { text: 'Έκπτωση (%)', value: 'discount_percentage' },
      { text: 'Ενέργειες', value: 'actions', sortable: false },
    ],

    editedProductEntry: { id: -1, product_id: null, price: 0 },
    editedCategoryEntry: { id: -1, category_id: null, discount_percentage: 0 },
    
    defaultProductEntry: { id: -1, product_id: null, price: 0 },
    defaultCategoryEntry: { id: -1, category_id: null, discount_percentage: 0 },
  }),

  computed: {
    pricelistId() {
        return this.$route.params.id;
    },
    pricelistType() {
        return this.$route.params.type || 'sales'; // Should now always be present
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
        const typeUrl = this.pricelistType === 'sales' ? '/api/pricelists/sales/' : '/api/pricelists/purchases/';
        
        axios.all([
            axios.get(typeUrl + this.pricelistId),
            axios.get(`/api/pricelists/${this.pricelistId}/product-entries`),
            axios.get(`/api/pricelists/${this.pricelistId}/category-entries`),
            axios.get('/api/products'), // Assuming this exists
            axios.get('/api/product-categories') // Assuming this exists
        ]).then(axios.spread((pricelist, pEntries, cEntries, products, categories) => {
            this.pricelist = pricelist.data;
            this.productEntries = pEntries.data;
            this.categoryEntries = cEntries.data;
            this.products = products.data;
            this.categories = categories.data;
        }));
    },
    
    getProductName(id) {
        const p = this.products.find(x => x.id == id);
        return p ? p.description : id;
    },

    getProductCode(id) {
        const p = this.products.find(x => x.id == id);
        return p ? p.code : '-';
    },

    getCategoryName(id) {
        const c = this.categories.find(x => x.id == id);
        return c ? c.name : id;
    },
    
    productDisplayName(item) {
        return `${item.code} - ${item.description}`;
    },

    // Product Entry Methods
    createProductEntry() {
        this.editedProductEntry = Object.assign({}, this.defaultProductEntry);
        this.productDialog = true;
    },
    editProductEntry(item) {
        this.editedProductEntry = Object.assign({}, item);
        this.productDialog = true;
    },
    deleteProductEntry(item) {
        if(confirm('Διαγραφή;')) {
            axios.post(`/api/pricelists/product-entries/${item.id}/delete`).then(() => {
                this.initialize();
            });
        }
    },
    saveProductEntry() {
        const payload = {
            pricelist_id: this.pricelistId,
            product_id: this.editedProductEntry.product_id,
            price: this.editedProductEntry.price
        };

        if (this.editedProductEntry.id === -1) {
            axios.post('/api/pricelists/product-entries', payload).then(() => {
                this.closeProductDialog();
                this.initialize();
            });
        } else {
             axios.post(`/api/pricelists/product-entries/${this.editedProductEntry.id}/update`, payload).then(() => {
                this.closeProductDialog();
                this.initialize();
            });
        }
    },
    closeProductDialog() {
        this.productDialog = false;
    },

    // Category Entry Methods
    createCategoryEntry() {
        this.editedCategoryEntry = Object.assign({}, this.defaultCategoryEntry);
        this.categoryDialog = true;
    },
    editCategoryEntry(item) {
        this.editedCategoryEntry = Object.assign({}, item);
        this.categoryDialog = true;
    },
    deleteCategoryEntry(item) {
         if(confirm('Διαγραφή;')) {
            axios.post(`/api/pricelists/category-entries/${item.id}/delete`).then(() => {
                this.initialize();
            });
        }
    },
    saveCategoryEntry() {
         const payload = {
            pricelist_id: this.pricelistId,
            category_id: this.editedCategoryEntry.category_id,
            discount_percentage: this.editedCategoryEntry.discount_percentage
        };

        if (this.editedCategoryEntry.id === -1) {
            axios.post('/api/pricelists/category-entries', payload).then(() => {
                this.closeCategoryDialog();
                this.initialize();
            });
        } else {
             axios.post(`/api/pricelists/category-entries/${this.editedCategoryEntry.id}/update`, payload).then(() => {
                this.closeCategoryDialog();
                this.initialize();
            });
        }
    },
    closeCategoryDialog() {
        this.categoryDialog = false;
    }
  }
};
</script>
